export enum DEVICE {
  MOBILE = 1,
  DESKTOP = 2,
}
